"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var BaseCommands = __importStar(require("./commands"));
var bash_1 = __importDefault(require("./bash"));
var styles_js_1 = __importDefault(require("./styles.js"));
var CTRL_CHAR_CODE = 17;
var L_CHAR_CODE = 76;
var C_CHAR_CODE = 67;
var UP_CHAR_CODE = 38;
var DOWN_CHAR_CODE = 40;
var TAB_CHAR_CODE = 9;
var noop = function () { };
var Terminal = /** @class */ (function (_super) {
    __extends(Terminal, _super);
    function Terminal(_a) {
        var extensions = _a.extensions, history = _a.history, structure = _a.structure, prefix = _a.prefix;
        var _this = _super.call(this) || this;
        _this.ticker = function () {
            _this.interval = setInterval(function () {
                _this.input.current.value += '.';
            }, 200);
        };
        _this.Bash = new bash_1.default(extensions);
        _this.ctrlPressed = false;
        _this.state = {
            settings: { user: { username: prefix.split('@')[1] } },
            history: history.slice(),
            structure: Object.assign({}, structure),
            cwd: '',
            loading: false,
        };
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleKeyUp = _this.handleKeyUp.bind(_this);
        _this.input = react_1.default.createRef();
        _this.body = react_1.default.createRef();
        _this.interval;
        return _this;
    }
    Terminal.prototype.getDerivedStateFromProps = function (_a) {
        var extensions = _a.extensions, structure = _a.structure, history = _a.history;
        var updatedState = {};
        if (structure) {
            updatedState.structure = Object.assign({}, structure);
        }
        if (history) {
            updatedState.history = history.slice();
        }
        if (extensions) {
            this.Bash.commands = Object.assign({}, extensions, BaseCommands);
        }
        this.setState(updatedState);
    };
    /*
     * Utilize immutability
     */
    Terminal.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (this.state !== nextState) || (this.props !== nextProps);
    };
    Terminal.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Keep input in view when interacting with component.
        this.body.current.scrollTo(0, this.body.current.scrollHeight);
        // Handle loading animation in Terminal component
        if (prevState.loading !== this.state.loading) {
            if (this.state.loading) {
                this.renderLoadingAnimation();
            }
            else {
                this.clearLoadingAnimation();
            }
        }
        // Handle parent request for loading animation
        if (prevProps.loading !== this.props.loading) {
            if (this.props.loading) {
                this.renderLoadingAnimation();
            }
            else {
                this.clearLoadingAnimation();
            }
        }
        if (prevProps.message !== this.props.message) {
            var value = this.props.message;
            this.setState({
                history: this.state.history.concat({ value: value }),
                loading: false,
            });
            this.props.resetMessage();
        }
    };
    /*
     * Forward the input along to the Bash autocompleter. If it works,
     * update the input.
     */
    // keydown returns undefined
    // is there a better way to show empty lines
    // but to also not have empty histories?
    // autocomplete should filter history to not have empty lines
    Terminal.prototype.attemptAutocomplete = function () {
        var input = this.input.current.value;
        var suggestion = this.Bash.autocomplete(input, this.state);
        if (suggestion) {
            this.input.current.value = suggestion;
        }
    };
    /*
     * Handle keydown for special hot keys. The tab key
     * has to be handled on key down to prevent default.
     * @param {Event} evt - the DOM event
     */
    Terminal.prototype.handleKeyDown = function (evt) {
        if (evt.which === CTRL_CHAR_CODE) {
            this.ctrlPressed = true;
        }
        else if (evt.which === TAB_CHAR_CODE) {
            // Tab must be on keydown to prevent default
            this.attemptAutocomplete();
            evt.preventDefault();
        }
    };
    /*
     * Handle keyup for special hot keys.
     * @param {Event} evt - the DOM event
     *
     * -- Supported hot keys --
     * ctrl + l : clear
     * ctrl + c : cancel current command
     * up - prev command from history
     * down - next command from history
     * tab - autocomplete
     */
    Terminal.prototype.handleKeyUp = function (evt) {
        if (evt.which === L_CHAR_CODE) {
            if (this.ctrlPressed) {
                this.setState(this.Bash.execute('clear', this.state));
            }
        }
        else if (evt.which === C_CHAR_CODE) {
            if (this.ctrlPressed) {
                this.input.current.value = '';
            }
        }
        else if (evt.which === UP_CHAR_CODE) {
            if (this.Bash.hasPrevCommand()) {
                this.input.current.value = this.Bash.getPrevCommand();
            }
        }
        else if (evt.which === DOWN_CHAR_CODE) {
            if (this.Bash.hasNextCommand()) {
                this.input.current.value = this.Bash.getNextCommand();
            }
            else {
                this.input.current.value = '';
            }
        }
        else if (evt.which === CTRL_CHAR_CODE) {
            this.ctrlPressed = false;
        }
    };
    Terminal.prototype.renderLoadingAnimation = function () {
        var _this = this;
        this.ticker();
        setTimeout(function () {
            _this.setState({ loading: false });
        }, 5000);
    };
    Terminal.prototype.clearLoadingAnimation = function () {
        this.input.current.value = '';
        clearInterval(this.interval);
    };
    Terminal.prototype.handleSubmit = function (e) {
        e.preventDefault();
        // Send terminal input to parent component
        this.props.getTerminalInput(e.target[0].value);
        // Prevent user interaction on loading
        if (this.state.loading) {
            return;
        }
        // Execute command
        var input = e.target[0].value;
        var newState = this.Bash.execute(input, this.state);
        this.setState(newState);
        this.input.current.value = '';
    };
    Terminal.prototype.renderHistoryItem = function (style) {
        var _this = this;
        return function (item, key) {
            var prefix = item.hasOwnProperty('cwd') ? (react_1.default.createElement("span", { style: style.prefix }, _this.props.prefix + " ~" + item.cwd + " $")) : undefined;
            return react_1.default.createElement("div", { "data-test-id": "history-" + key, key: key },
                react_1.default.createElement("pre", { style: { margin: 0 } },
                    prefix,
                    item.value));
        };
    };
    Terminal.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClose = _a.onClose, onExpand = _a.onExpand, onMinimize = _a.onMinimize, prefix = _a.prefix, styles = _a.styles, theme = _a.theme;
        var _b = this.state, history = _b.history, cwd = _b.cwd;
        var style = Object.assign({}, styles_js_1.default[theme] || styles_js_1.default.dark, styles);
        return (react_1.default.createElement("div", { className: "ReactBash", style: style.ReactBash },
            react_1.default.createElement("div", { style: style.header },
                react_1.default.createElement("span", { style: style.redCircle, onClick: onClose }),
                react_1.default.createElement("span", { style: style.yellowCircle, onClick: onMinimize }),
                react_1.default.createElement("span", { style: style.greenCircle, onClick: onExpand })),
            react_1.default.createElement("div", { ref: this.body, style: style.body, onClick: function () { return _this.input.current.focus(); } },
                history.map(this.renderHistoryItem(style)),
                react_1.default.createElement("form", { onSubmit: function (e) { return _this.handleSubmit(e); }, style: style.form },
                    react_1.default.createElement("span", { style: style.prefix }, prefix + " ~" + cwd + " $"),
                    react_1.default.createElement("input", { autoComplete: "off", onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, ref: this.input, style: style.input })))));
    };
    return Terminal;
}(react_1.Component));
exports.default = Terminal;
Terminal.Themes = {
    LIGHT: 'light',
    DARK: 'dark',
};
Terminal.propTypes = {
    extensions: prop_types_1.default.object,
    history: prop_types_1.default.array,
    onClose: prop_types_1.default.func,
    onExpand: prop_types_1.default.func,
    onMinimize: prop_types_1.default.func,
    prefix: prop_types_1.default.string,
    structure: prop_types_1.default.object,
    styles: prop_types_1.default.object,
    theme: prop_types_1.default.string,
};
Terminal.defaultProps = {
    extensions: {},
    history: [],
    onClose: noop,
    onExpand: noop,
    onMinimize: noop,
    prefix: 'hacker@default',
    structure: {},
    styles: {},
    theme: Terminal.Themes.DARK,
};
//# sourceMappingURL=component.js.map